import React from "react";
import { Form, Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import Footer from "../../component/Footer";
import "../../assets/new/css/MyDiary.css";
import "../../assets/new/css/SchoolTvChannel.css";
import "../../assets/new/css/Forum.css";
import { BsSend } from "react-icons/bs";
import { BiLike, BiDislike, BiSolidDislike, BiSolidLike } from "react-icons/bi";
import { MdOutlineModeComment } from "react-icons/md";
import BreadCrumbs from "../../component/BreadCrumbs";
import forum_img_3 from "../../assets/new/images/DiaryIcon.svg";
import reply_icon from "../../assets/new/images/MyDiary/reply_icon.svg";

const NewForumView = ({ t }) => {
  return (
    <>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper sidebar-icon">
          <div className="page-body" id="container">
            <BreadCrumbs />
            <div className="Note_view Forum">
              <div className="main-section">
                <div className="row">
                  <div className="col-md-12">
                    <div className="announcement-top">
                      <h4>{t("Forums")}</h4>
                    </div>
                    <div className="forumviewborder">
                      <div className="class-text-wrapper">
                        <div className="forum-header">
                          <div className="forum-img">
                            <img src={forum_img_3} alt="" />
                          </div>
                          <div className="forum-title-wrapper">
                            <p className="ft-main-title">Forum Title</p>
                            <p className="ft-sub-title">Category Name</p>
                            <p className="ft-date">December 5, 2024</p>
                          </div>
                        </div>
                      </div>
                      <div className="test-desc">
                        Forum description goes here...
                      </div>
                      <div className="forum-img-wrapper">
                        {/* Placeholder for forum attachment */}
                        <div className="imagesIf">
                          <img
                            width="100%"
                            height="500px"
                            className="responsive-iframe imagesIf"
                            src="placeholder-image.jpg"
                            alt="Forum content"
                          />
                        </div>
                      </div>
                      <div className="forum-footer border-bottom">
                        <div className="like-btn">
                          <BiSolidLike
                            style={{
                              width: "18px",
                              height: "18px",
                              color: "#ADC927",
                            }}
                          />
                          <span>42</span>
                        </div>
                        <div className="dislike-btn">
                          <BiSolidDislike
                            style={{
                              width: "18px",
                              height: "18px",
                              color: "#ADC927",
                            }}
                          />
                          <span>3</span>
                        </div>
                        <div className="comments-btn">
                          <MdOutlineModeComment
                            style={{
                              width: "18px",
                              height: "18px",
                              color: "#758522",
                            }}
                          />
                          <span>15</span>
                        </div>
                      </div>
                      <p className="title">{t("Comments")}</p>
                      <div className="comments-wrapper">
                        <div className="single-comment">
                          <div className="com-img-box">
                            <img
                              src="user-profile.jpg"
                              alt="User"
                              style={{ width: "35px", height: "28px" }}
                            />
                          </div>
                          <div className="text-wrapper">
                            <div className="com-heading-wrapper">
                              <p className="title">User Name (Designation)</p>
                              <div className="time-and-like">
                                <div className="time">
                                  Dec 5, 2023, 10:30 AM
                                </div>
                              </div>
                            </div>
                            <div className="comment-text">
                              <p>This is a sample comment text.</p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div className="reply-btn-wrapper">
                                <img src={reply_icon} alt="" />
                                <span>{t("Reply")}</span>
                              </div>
                              <div className="comments-btn">
                                <MdOutlineModeComment
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    color: "#758522",
                                    fontWeight: "bold",
                                  }}
                                />
                                <span className="margin-left">5 comments</span>
                              </div>
                            </div>
                            <Form>
                              <Form.Group
                                className="mb-3 mt-2"
                                controlId="formBasicEmail"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Form.Control
                                    type="text"
                                    placeholder={t("Type Your Comment Here...")}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "32px",
                                      padding: "9px",
                                    }}
                                  >
                                    <BsSend
                                      color="#758522"
                                      style={{ marginRight: "10px" }}
                                    />
                                  </div>
                                </div>
                              </Form.Group>
                            </Form>
                            <div className="teachers-reply">
                              <div className="single-comment mt-3">
                                <div className="com-img-box">
                                  <img
                                    src="user-profile.jpg"
                                    alt="User"
                                    style={{ width: "35px", height: "28px" }}
                                  />
                                </div>
                                <div className="text-wrapper">
                                  <div className="com-heading-wrapper">
                                    <p className="title">
                                      Reply User (Designation)
                                    </p>
                                    <div className="time-and-like">
                                      <div className="time">
                                        Dec 5, 2023, 11:30 AM
                                      </div>
                                    </div>
                                  </div>
                                  <div className="comment-text">
                                    <p>This is a sample reply.</p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div className="reply-btn-wrapper">
                                      <img src={reply_icon} alt="" />
                                      <span>{t("Reply")}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="main-comment-input-wrapper">
                  <Form>
                    <Form.Group
                      className="sendbutton"
                      controlId="formBasicEmail"
                    >
                      <Form.Control
                        type="text"
                        placeholder={t("Write Comment…")}
                      />
                      <div>
                        <BsSend
                          color="#758522"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default withTranslation()(NewForumView);
